import { baseApi } from "../baseApi";

const selectInputApis = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPriorities: builder.query<any, void>({
      query: () => "/gw/priorities",
      providesTags: ["Priority"],
    }),
    getCategories: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
          : "";
        return `/gw/categories${queryString}`;
      },
      providesTags: ["Category"],
    }),
    getSubcategories: builder.query<any, number | void>({
      query: (categoryId) => {
        const resolvedId =
          typeof categoryId === "object" && categoryId !== null
            ? (categoryId as any)?.category_id ?? (categoryId as any)?.id
            : categoryId;

        return resolvedId
          ? `/gw/subcategories?category_id=${resolvedId}`
          : "/gw/subcategories";
      },
      transformResponse: (response: any) => {
        const payload = response?.data ?? response;
        if (!payload) return payload;
        if (Array.isArray(payload)) {
          return { items: payload };
        }
        if (payload?.items) return payload;
        if (payload?.subcategories) return { items: payload.subcategories };
        return payload;
      },
      providesTags: ["Subcategory"],
    }),
    getClients: builder.query<any, Record<string, any> | void>({
      query: (filter) => {
        const queryParams = filter
          ? new URLSearchParams(filter).toString()
          : "";
        return queryParams ? `/clients?${queryParams}` : "/clients";
      },
      providesTags: ["Client"],
    }),
    getStatuses: builder.query<any, void>({
      query: () => "/gw/status",
      providesTags: ["Status"],
    }),
    getUpdateReasons: builder.query<any, void>({
      query: () => "/gw/update-reasons",
      providesTags: ["UpdateReason"],
    }),
    getAgents: builder.query<any, void>({
      query: () => "/agents",
      providesTags: ["Agent"],
    }),
  }),
});

export const {
  useGetPrioritiesQuery,
  useGetCategoriesQuery,
  useGetSubcategoriesQuery,
  useGetClientsQuery,
  useLazyGetClientsQuery,
  useGetStatusesQuery,
  useGetUpdateReasonsQuery,
  useGetAgentsQuery,
} = selectInputApis;
